import apiClient from '../utils/api';

export interface OccasionDto {
  occasionId: string;
  title: string;
  description?: string;
  imageUrl?: string;
  createdAt: string;
  updatedAt: string;
}

export interface OccasionsResponse {
  message: string;
  data: {
    occasions: OccasionDto[];
    pagination?: any;
  };
  timestamp: string;
}

export const occasionsService = {
  getAllOccasions: async (limit: number = 100): Promise<OccasionsResponse> => {
    const response = await apiClient.get<OccasionsResponse>('/occasions', {
      params: { limit },
    });
    return response.data;
  },
};
